import './App.css';
import './Assets/scss/style.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Routes as GlobalRoutes } from "./constants/RouteConstants";
import Login from './component/login/Login';
import Signup from './component/signup/Signup';
import CompleteProfile from './component/signup/CompleteProfile';
import Home from './component/home/Home';
import PrivateRoute from './router/PrivateRoutes';
import PublicOnlyRoute from './router/PublicOnlyRoute';
import Layout from './component/layout/Layout';
import { routeComponents } from './config/RouteConfig';
import DraftPage from './component/draft/DraftPage';
import NewAddressPageRoute from './component/address/NewAddressPageRoute';
import UpdateAddressRoute from './Modal/UpdateAddressRoute';
import ToastDefault from './component/layout/Toast';
import Cms from './component/cms/Cms';
import ContactSupportPage from './component/layout/ContactSupportPage';
import Faq from './component/faq/Faq';
import { Config } from './config/Config';
import Product from './component/product/Product';
import ProductDetails from './component/product/ProductDetails';
import AppCms from './component/cms/AppCms';
import UserFaq from './component/faq/UserFaq';
import PageNotFound from './component/layout/PageNotFound';
import Success from './component/layout/Success';
import { ContactSupportModalProvider } from './context/ContactSupportModalContext';
import Cancel from './component/layout/Cancel';
import PaymentFailed from './component/layout/PaymentFailed';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveToStorage, getFromStorage, syncMomentLocaleFromAppLanguage } from './utils/Helper';
import { isAppHomePath, isAppListPagePath, isAppOnboardingLoaderPath } from './utils/appPath';
import { LOGIN_DEBUG_SESSION_KEY, StorageConstant } from './constants/Constants';
import FrontLoader from './component/layout/FrontLoader';
import { ProfileAction } from './redux/Action/Authaction';
import { applyLanguageDisplayOverrides } from './constants/languageDisplayOverrides';
import { MyOrdersPageBodyClass } from './component/myorder/MyOrdersPageBodyClass';


function App() {
  const dispatch = useDispatch();
  /** When a token exists, wait for profile before painting routes (avoids logged-in UI flash / wrong state). */
  const [authHydrated, setAuthHydrated] = useState(() => {
    if (typeof window === 'undefined') return true;
    try {
      const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN });
      return !token;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    applyLanguageDisplayOverrides();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN });
    if (!token) return;

    let cancelled = false;
    void (async () => {
      try {
        // @ts-ignore redux-thunk
        await dispatch(ProfileAction(undefined));
      } catch {
        /* profile bootstrap failed; still unblock UI */
      } finally {
        if (!cancelled) setAuthHydrated(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  const publicRoutes = [
    {
      path: GlobalRoutes?.Login,
      element: (
        <PublicOnlyRoute>
          <Login />
        </PublicOnlyRoute>
      ),
    },
    {
      path: GlobalRoutes?.Signup,
      element: (
        <PublicOnlyRoute>
          <Signup />
        </PublicOnlyRoute>
      ),
    },
    {
      path: GlobalRoutes?.CompleteProfile,
      element: <CompleteProfile />,
    },
    {
      path: GlobalRoutes?.AppPrivacyPolicyCMS,
      element: <AppCms />,
    },
    {
      path: GlobalRoutes?.AppTermCondition,
      element: <AppCms />,
    },
    {
      path: GlobalRoutes?.AppAboutUs,
      element: <AppCms />,
    },
    {
      path: GlobalRoutes?.UserFaq,
      element: <UserFaq />,
    },
    {
      path: GlobalRoutes?.Paymentsuccess,
      element: <Success />,
    },
    {
      path: GlobalRoutes?.Paymentscancel,
      element: <Cancel />,
    },
    {
      path: GlobalRoutes?.PaymentFailed,
      element: <PaymentFailed />,
    },
    {
      path: GlobalRoutes?.PageNotFound,
      element: <PageNotFound />,
    },
   

  ]

  useEffect(() => {
    if (!localStorage.getItem('Translate')) {
      saveToStorage({ key: 'Translate', value: 'en' });
    }
    syncMomentLocaleFromAppLanguage();
  }, []);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(LOGIN_DEBUG_SESSION_KEY);
      if (!raw) return;
      sessionStorage.removeItem(LOGIN_DEBUG_SESSION_KEY);
      const parsed = JSON.parse(raw);
      console.log(
        '%c[QNB Login] after redirect — last sign-in debug',
        'font-size:13px;font-weight:700;color:#1a5f7a;padding:4px 0',
        parsed
      );
      if (parsed?.api) console.log('[QNB Login] api snapshot', parsed.api);
      if (parsed?.storageAfterSave) console.log('[QNB Login] storage after save', parsed.storageAfterSave);
      if (parsed?.phase === 'login_failed') console.warn('[QNB Login] failure detail', parsed);
    } catch (e) {
      console.warn('[QNB Login] could not read login debug from sessionStorage', e);
    }
  }, []);


  const hasAccessToken = (() => {
    if (typeof window === 'undefined') return false;
    try {
      return Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }));
    } catch {
      return false;
    }
  })();

  /**
   * Logged-in home: mount routes immediately so DashboardHome blur/skeleton renders on first paint.
   * Other private routes still wait for profile bootstrap (avoids header/profile UI flash).
   */
  const renderHomeDuringAuthBootstrap = hasAccessToken && isAppHomePath();
  const renderListPagesDuringAuthBootstrap = hasAccessToken && isAppListPagePath();
  const renderOnboardingDuringAuthBootstrap =
    hasAccessToken && isAppOnboardingLoaderPath();
  const blockRoutesUntilAuth =
    !authHydrated &&
    !renderHomeDuringAuthBootstrap &&
    !renderListPagesDuringAuthBootstrap &&
    !renderOnboardingDuringAuthBootstrap;

  return (
    <>
      {blockRoutesUntilAuth && hasAccessToken ? <FrontLoader /> : null}
      {!blockRoutesUntilAuth ? (
      <BrowserRouter basename={Config?.BASE_URL}>
        <MyOrdersPageBodyClass />
        <ContactSupportModalProvider>
        {/* <Header /> */}
        <Routes >
        <Route element={<Layout />}>
                <Route path={"/"} element={<Home/>} ></Route>
                <Route path={"/cms/contact-support"} element={<ContactSupportPage />} ></Route>
                <Route path={"/cms/:id"} element={<Cms/>} ></Route>
                <Route path={"/faq"} element={<Faq/>} ></Route>
                <Route path={"/product"} element={<Product/>} ></Route>
                <Route path={"/productdetail/:id"} element={<ProductDetails/>} ></Route>
                {/* <Route path={"*"} element={<PageNotFound/>} ></Route> */}
         </Route>
          <Route>
            {
              publicRoutes?.map((route: any, routeKey: any) => {
                return <Route path={route?.path} element={route?.element} key={routeKey} />
              })
            }
          </Route>
          <Route element={<PrivateRoute component={Layout} />}>
            <Route path={GlobalRoutes.Drafts} element={<DraftPage />} />
            <Route path={GlobalRoutes.AddressCreate} element={<NewAddressPageRoute />} />
            <Route path={GlobalRoutes.AddressEdit} element={<UpdateAddressRoute />} />
            {routeComponents}
          </Route>
        </Routes>
        {/* <Footer /> */}
        </ContactSupportModalProvider>
      </BrowserRouter>
      ) : null}
      <ToastDefault />
    </>
  );
}

export default App;
